import { Navigate } from 'react-router-dom';

// Existing In3D.ai privacy terms remain the authoritative policy.
export default function CookiePolicy() {
  return <Navigate to="/privacy-policy" replace />;
}
